import _pickBy from 'lodash/pickBy';

const commissionFilters = filters => _pickBy(filters, filter => !!filter);

export default commissionFilters;
